var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "modal",
      class: ["modal", "fade", { show: _vm.shown }],
      style: { display: _vm.shown ? "block" : "none" },
      attrs: {
        id: _vm.id,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": _vm.ariaLabelledById,
        "aria-hidden": !_vm.shown,
        "aria-modal": "true",
      },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.handleEscape.apply(null, arguments)
        },
        click: function ($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.onBackdropClick.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          class: _vm.modalDialogClass,
          attrs: { role: "document" },
        },
        [
          _vm._t("content", function () {
            return [
              _c(
                "div",
                { staticClass: "modal-content" },
                [
                  !_vm.noHeader
                    ? _c("div", { staticClass: "modal-header" }, [
                        _c(
                          "div",
                          {
                            staticClass: "modal-title",
                            attrs: { id: _vm.ariaLabelledById },
                          },
                          [_vm._t("header")],
                          2
                        ),
                        _vm._v(" "),
                        !_vm.disableClose
                          ? _c(
                              "button",
                              {
                                ref: "closeButton",
                                staticClass: "close",
                                attrs: {
                                  type: "button",
                                  "data-dismiss": "modal",
                                  "aria-label": _vm.i18n.close,
                                },
                                on: { click: _vm.close },
                              },
                              [
                                _vm._t("close", function () {
                                  return [
                                    _c(
                                      "span",
                                      { attrs: { "aria-hidden": "true" } },
                                      [_vm._v("×")]
                                    ),
                                  ]
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._t("default"),
                  _vm._v(" "),
                  _vm.$slots.body
                    ? _c("div", { class: ["modal-body"] }, [_vm._t("body")], 2)
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.noFooter
                    ? _c(
                        "div",
                        { staticClass: "modal-footer" },
                        [
                          _vm._t(
                            "footer",
                            function () {
                              return [
                                _c(
                                  "ui-button",
                                  {
                                    ref: "cancelButton",
                                    attrs: {
                                      "data-dismiss": "modal",
                                      appearance: _vm.appearance,
                                      "button-type": "outline",
                                      block: "",
                                      uppercase: "",
                                      disabled: _vm.disableClose,
                                    },
                                    on: { click: _vm.close },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.i18n.cancel) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.handleConfirm
                                  ? _c(
                                      "ui-button",
                                      {
                                        ref: "confirmButton",
                                        attrs: {
                                          appearance: _vm.appearance,
                                          block: "",
                                          uppercase: "",
                                          disabled: _vm.disableConfirm,
                                        },
                                        on: { click: _vm.confirm },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.i18n.ok) +
                                            "\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                            { close: _vm.close, confirm: _vm.confirm }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }